/* Dogscan Advertorial: Hero-Varianten, UTM-Weitergabe, CTA-Event, Lesefortschritt, Sticky-CTA */
(function () {
  var doc = document;

  /* --- Hero-Varianten für Meta-Angles (?v=b oder ?v=c). Texte pflegt man im Theme-Editor (Hero-Section). --- */
  var variant = 'a';
  try {
    var v = (new URLSearchParams(location.search).get('v') || '').toLowerCase();
    var dataEl = doc.getElementById('dsaVariants');
    var variants = dataEl ? JSON.parse(dataEl.textContent) : {};
    var chosen = variants[v];
    if (chosen && chosen.h1) {
      variant = v;
      var kicker = doc.getElementById('dsaEyebrow');
      var h1 = doc.getElementById('dsaH1');
      var sub = doc.getElementById('dsaSub');
      if (kicker && chosen.kicker) kicker.textContent = chosen.kicker;
      if (h1) h1.textContent = chosen.h1;
      if (sub && chosen.teaser) sub.textContent = chosen.teaser;
    }
  } catch (e) {}
  doc.documentElement.setAttribute('data-dsa-variant', variant);

  /* --- UTM/Klick-IDs an Shop-Links weitergeben, damit Attribution nicht verloren geht --- */
  var KEYS = ['utm_source', 'utm_medium', 'utm_campaign', 'utm_content', 'utm_term', 'fbclid', 'gclid', 'gbraid', 'wbraid'];
  var params = {};
  try {
    var sp = new URLSearchParams(location.search);
    KEYS.forEach(function (k) { if (sp.get(k)) params[k] = sp.get(k); });
  } catch (e) {}
  if (variant !== 'a' && !params.utm_content) params.utm_content = 'adv-' + variant;
  doc.querySelectorAll('a[data-dsa-cta]').forEach(function (a) {
    try {
      var u = new URL(a.getAttribute('href'), location.href);
      Object.keys(params).forEach(function (k) { if (!u.searchParams.has(k)) u.searchParams.set(k, params[k]); });
      a.href = u.toString();
    } catch (e) {}
  });

  /* --- CTA-Klick als dataLayer-Event für GTM (kein eigener Pixel) --- */
  doc.addEventListener('click', function (e) {
    var a = e.target.closest && e.target.closest('a[data-dsa-cta]');
    if (!a) return;
    window.dataLayer = window.dataLayer || [];
    window.dataLayer.push({ event: 'advertorial_cta_click', cta_position: a.getAttribute('data-dsa-cta'), advertorial_variant: variant });
  });

  /* --- Lesefortschritt --- */
  var fill = doc.getElementById('dsaProgress');
  if (fill) {
    var ticking = false;
    var progress = function () {
      var h = doc.documentElement.scrollHeight - innerHeight;
      fill.style.transform = 'scaleX(' + (h > 0 ? Math.min(1, scrollY / h) : 0) + ')';
      ticking = false;
    };
    addEventListener('scroll', function () { if (!ticking) { ticking = true; requestAnimationFrame(progress); } }, { passive: true });
    progress();
  }

  /* --- Sticky-CTA: ab dem Anker mit data-dsa-sticky-start, weg sobald ein [data-dsa-sticky-hide] sichtbar ist --- */
  var sticky = doc.getElementById('dsaSticky');
  var startEl = doc.querySelector('[data-dsa-sticky-start]') || doc.getElementById('mechanismus');
  if (sticky && startEl) {
    var stickyLink = sticky.querySelector('a');
    var blockers = Array.prototype.slice.call(doc.querySelectorAll('[data-dsa-sticky-hide]'));
    var visible = null;
    var checkSticky = function () {
      var vh = innerHeight;
      var on = startEl.getBoundingClientRect().top < vh * 0.25;
      blockers.forEach(function (b) {
        var r = b.getBoundingClientRect();
        if (r.top < vh && r.bottom > 0) on = false;
      });
      if (on === visible) return;
      visible = on;
      sticky.classList.toggle('is-on', on);
      sticky.setAttribute('aria-hidden', on ? 'false' : 'true');
      if (stickyLink) stickyLink.tabIndex = on ? 0 : -1;
    };
    addEventListener('scroll', checkSticky, { passive: true });
    addEventListener('resize', checkSticky);
    checkSticky();
  }
})();
